import { useSyncExternalStore } from 'react'
import { pubSub } from '../../app-state/pubSub'
import { getRoomsState } from '../../app-state/state.rooms'
import { getActiveRooms } from '../../mfcLogic/rooms'
import { subRoom } from './useRoom'

const getRooms = () => getRoomsState()
const subRooms = (callback: () => void) => pubSub.ROOM.on('state', callback)
const getRoomsCount = () => getActiveRooms(getRoomsState()).length

export const useRooms = () => {
    return useSyncExternalStore(subRooms, getRooms, getRooms)
}

export const useRoomsCount = (): number => {
    return useSyncExternalStore(subRoom, getRoomsCount, getRoomsCount)
}
